module.exports = __webpack_public_path__ + "img/ez-slot-category-skill-game-hover.c28e67b8.png";